// extracted by mini-css-extract-plugin
module.exports = {"h1r84kl9":"h1r84kl9","hhmilo9":"hhmilo9"};